module.exports = __webpack_public_path__ + "img/invoice.810475bd.jpeg";